import React from 'react';
import PropTypes from 'prop-types';

import PriceType from 'apps/products/models/PriceType';
import { priceFormat } from 'apps/products/utils/priceFormat';

export default function MainPrice(props) {
  const {
    currentPrice,
    isValueDeliveredProduct = false,
    lowPricePromise,
    type,
    zeroAfterPound = true,
  } = props;

  let currentPriceElement = null;
  if (currentPrice) {
    let currentPriceClass = 'fop-price';
    if (lowPricePromise) {
      currentPriceClass += ' fop-lpp';
    }
    if (isValueDeliveredProduct) {
      currentPriceClass += ' fop-value-delivered';
    }
    if (type === PriceType.OFFER) {
      currentPriceClass += ' price-offer';
    }
    currentPriceElement = (
      <span className={currentPriceClass}>{priceFormat({ value: currentPrice, zeroAfterPound })}</span>
    );
  }
  return currentPriceElement;
}

MainPrice.propTypes = {
  currentPrice: PropTypes.number,
  lowPricePromise: PropTypes.bool,
  zeroAfterPound: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(PriceType)).isRequired,
};
